<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card-box m-0">
                <form role="form" @submit.prevent="doFilter(1)">
                    <div class="input-group m-b-15">
                        <input type="text" v-model="filter.search" class="form-control input_search" :placeholder="$t('_sent_emails.filter_main_field_placeholder')">
                        <span class="input-group-btn">
                            <span class="btn btn_green" @click.prevent="doFilter(1)" v-pml-tooltip="$t('filter')">
                                <i class="fa fa-fw fa-search"></i>
                            </span>
                        </span>
                    </div>
                    <div>
                        <div class="row">
                            <div class="col-xs-12 col-sm-6 col-md-6 m-b-15">
                                <label>{{ $t('sent_at') }}</label>
                                <div class="input-daterange input-group">
                                    <pml-date-picker v-model="filter.created_at_from"></pml-date-picker>
                                    <span class="input-group-addon b-0"><i class="fa fa-calendar"></i></span>
                                    <pml-date-picker v-model="filter.created_at_to"></pml-date-picker>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 m-b-15">
                                <label>{{ $t('consultant') }}</label>
                                <pml-select-members v-model="filter.member_id" :onlyActive="true"></pml-select-members>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 m-b-15">
                                <label>{{ $t('sent_by') }}</label>
                                <pml-multiselect v-model="filter.senders" :options="senders"></pml-multiselect>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 m-b-15">
                                <label>{{ $t('status') }}</label>
                                <pml-multiselect v-model="filter.status_s" :options="status"></pml-multiselect>
                            </div>
                            <div class="col-xs-12 col-sm-6 m-b-15">
                                <label>{{ $t('source') }}</label>
                                <pml-select v-model="filter.source_id" :options="sources"></pml-select>
                            </div>
                            <div class="col-xs-12 col-sm-6 m-b-15">
                                <label>{{ $t('segment') }}</label>
                                <pml-select v-model="filter.segment_id" :options="segments"></pml-select>
                            </div>
                        </div>
                    </div>
                    <hr class="m-t-0">
                    <div class="clearfix text-center">
                        <span class="btn btn-white pull-left" @click.prevent="clear()"><i class="fa fa-paint-brush m-r-5"></i> {{ $t('clear') }}</span>
                        <router-link :to="{ name: 'sent-emails.create'}" class="btn btn-default">
                            <span class="btn-label">
                                <i class="fa fa-plus-circle"></i>
                            </span>
                            {{ $t('email') }}
                        </router-link>
                        <button class="btn btn_green pull-right" type="submit">
                            <span class="btn-label">
                                <i class="fa fa-search"></i>
                            </span>
                            {{ $t('filter') }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import bus from 'utils/events/bus'
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { getAllPaged } from 'services/emails'
    import { mapGetters } from 'vuex'

    export default {
        name: 'EmailsFilter',
        data () {
            return {
                page: 1,
                pagination: {
                    from: 0,
                    to: 0,
                    total: 0
                },
                filter: {
                    created_at_from: '',
                    created_at_to: '',
                    source_id: null,
                    segment_id: null,
                    orderBy: 'created_at',
                    orderDirection: 'desc',
                    status_s: ['click', 'delivered', 'open']
                }
            }
        },
        computed: {
            ...mapGetters({
                'sources': 'getSources',
                'segments': 'getSegments',
                'status': 'getEmailStatus',
                'senders': 'getEmailSenders'
            })
        },
        created () {
            bus.$on('doFilterEmails', this.doFilter)
            bus.$on('orderRefreshEmails', this.orderRefresh)
            let storeStatus = window.localStorage.getItem('pml_emails_status_s')

            if (typeof storeStatus === 'string' && storeStatus && storeStatus !== 'null' && storeStatus !== 'undefined')
                this.filter.status_s = storeStatus.split(',')

            window.localStorage.removeItem('pml_emails_status_s')
        },
        destroyed () {
            bus.$off('doFilterEmails')
            bus.$off('orderRefreshEmails')
        },
        methods: {
            clear () {
                this.filter = {
                    created_at_from: '',
                    created_at_to: '',
                    source_id: null,
                    segment_id: null,
                    orderBy: 'created_at',
                    orderDirection: 'desc',
                    status_s: []
                }
                this.doFilter(1)
            },
            doFilter (page = null) {
                bus.$emit('listLoadingEmails', true)

                this.page = page === null ? this.page : page

                getAllPaged(this.page, this.filter)
                    .then(response => {
                        this.pagination = response.data
                        bus.$emit('paginationRefreshEmails', response.data)
                    })
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => bus.$emit('listLoadingEmails', false))
            },
            orderRefresh (obj) {
                this.filter.orderBy = obj.orderProp
                this.filter.orderDirection = obj.orderDir
                this.doFilter(1)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/emails/components/Filter.vue